export default "__VITE_ASSET__D4COKJG4__"